const appData = {
    appVersion: "1.5.0",
}

export const appVersion = appData?.appVersion;